import axios from "axios";
import { loggedIn, logout } from "./Auth";

const axiosAPI = axios.create({
  baseURL: '/api/' 
});

const apiRequest = (method, url, request = {}) => {

  let headers = {};

  if (loggedIn) {
    let token = sessionStorage.getItem('token');
    headers.authorization = 'bearer ' + token;
    request.user = {
      name: sessionStorage.getItem('user'),
      id: sessionStorage.getItem('userID')
    };
  }

  return axiosAPI({
    method,
    url,
    data: request,
    headers
  }).then(res => {
    return Promise.resolve(res.data);
  })
    .catch(err => {
      if (err.response) {
        if (err.response.status === 401) {
          logout();
        }
      }
      return Promise.reject(err);
    });
};

const get = (url, request) => apiRequest("get", url, request);
const deleteRequest = (url, request) => apiRequest("delete", url, request);
const post = (url, request) => apiRequest("post", url, request);
const put = (url, request) => apiRequest("put", url, request);
const patch = (url, request) => apiRequest("patch", url, request);

const API = {
  get,
  delete: deleteRequest,
  post,
  put,
  patch
};
export default API;